import { Component, ComponentFactoryResolver, ViewChild, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';

import { ManufacturerDashboardComponent } from '../../../components/manufacturer-dashboard/manufacturer-dashboard.component';
import { AppViewDirective } from '../../app-view.directive';
import { ProductsListComponent } from '../../../components/products-list/products-list.component';
import { IncidentsComponent } from '../../../components/incidents/incidents.component';
import { LocationsComponent } from '../../../components/locations/locations.component';
import { ExpiryReportComponent } from '../../../components/expiry-report/expiry-report.component';
import { RecallSimulationComponent } from '../../../components/recall-simulation/recall-simulation.component';
import { RecallReportComponent } from '../../../components/recall-report/recall-report.component';
import { ManageBatchComponent } from '../../../components/manage-batch/manage-batch.component';
import { ManageMedicineComponent } from '../../../components/manage-medicine/manage-medicine.component';
import { ManageLocationComponent } from '../../../components/manage-location/manage-location.component';
import { EditProfileComponent } from '../../../components/edit-profile/edit-profile.component';
import { ManageLabelComponent } from '../../../components/manage-label/manage-label.component';
import { ManageAssetComponent } from '../../../components/manage-asset/manage-asset.component';
import { ManageDeviceComponent } from '../../../components/manage-device/manage-device.component';
import { LiveTrackingComponent } from 'src/components/live-tracking/live-tracking.component';
import { ManageChainComponent } from 'src/components/manage-chain/manage-chain.component';
import { ManageUserComponent } from 'src/components/manage-user/manage-user.component';
import { PrintLabelComponent } from 'src/components/print-label/print-label.component';
import { ManagePackageComponent } from 'src/components/manage-package/manage-package.component';
import { DeleteBatchComponent } from 'src/components/delete-batch/delete-batch.component';
import { EpicsNewImportComponent } from 'src/components/epics-new-import/epics-new-import.component';
import { RequestNotificationDialogComponent } from '../../../components/request-notification-dialog/request-notification-dialog.component';
import { ManageBillingComponent } from 'src/components/manage-billing/manage-billing.component';

import { GlobalCfgService } from '../../../services/globalcfg.service';
import { EventBusService } from '../../../services/event-bus.service';
import { MiscService } from '../../../services/misc.service';
import { UserService } from '../../../services/user.service';
import { NotificationsService } from 'src/services/notifications.service';
import { RedirectService } from 'src/services/redirect.service';
import { SidenavbarViewService } from '../../../services/sidenavbar-view.service';

@Component({
	selector: 'rm-manufacturer',
	templateUrl: './manufacturer.component.html',
	styleUrls: ['./manufacturer.component.css']
})
export class ManufacturerComponent implements OnInit, OnDestroy {

	@ViewChild(AppViewDirective, { static: true }) appViewHost: AppViewDirective;
	role: any;
	view: any;
	subcriptions: any[] = [];

	constructor(
		private componentFactoryResolver: ComponentFactoryResolver,
		private router: Router,
		private route: ActivatedRoute,
		private globalCfgService: GlobalCfgService,
		private userService: UserService,
		private miscService: MiscService,
		private ebService: EventBusService,
		private notifyService: NotificationsService,
		private dialog: MatDialog,
		private redirectService: RedirectService,
		private sidenavbarViewService: SidenavbarViewService
	) { }

	ngOnInit() {
		var user = this.globalCfgService.getLoggedInUser();

		this.route.parent.url.subscribe((url) => {
			var v = url.values();
			//always the first part is role
			this.role = v.next().value.path;
		});

		this.route.url.subscribe((url) => {
			var v = url.values();
			this.view = v.next().value.path;
			this.sidenavbarViewService.childView = this.view;
		});

		this.subcriptions.push(this.ebService.onReadyValue$.subscribe(
			() => {
				var cmpMap = {
					'dashboard': ManufacturerDashboardComponent,
					'products': ProductsListComponent,
					'incidents': IncidentsComponent,
					'locations': LocationsComponent,
					'expiry-report': ExpiryReportComponent,
					'batch-recall': RecallSimulationComponent,
					'recall-report': RecallReportComponent,
					'manage-batch': ManageBatchComponent,
					'manage-medicine': ManageMedicineComponent,
					'manage-location': ManageLocationComponent,
					'manage-profile': EditProfileComponent,
					'manage-label': ManageLabelComponent,
					'manage-asset': ManageAssetComponent,
					'manage-device': ManageDeviceComponent,
					'live-tracking': LiveTrackingComponent,
					'manage-chain': ManageChainComponent,
					'manage-user': ManageUserComponent,
					'print-label': PrintLabelComponent,
					'delete-batch': DeleteBatchComponent,
					'manage-package': ManagePackageComponent,
					'import': EpicsNewImportComponent,
					'manage-billing': ManageBillingComponent
				};

				var type = this.route.data['value']['type'];

				let componentFactory;

				if (!type) {
					componentFactory = this.componentFactoryResolver.resolveComponentFactory(ManufacturerDashboardComponent);
				} else {
					componentFactory = this.componentFactoryResolver.resolveComponentFactory(cmpMap[type]);
				}

				const viewContainerRef = this.appViewHost.viewContainerRef;
				viewContainerRef.clear();

				let componentRef = viewContainerRef.createComponent(componentFactory);
			}
		));

		if (!user || Object.keys(user).length == 0) {
			this.router.navigateByUrl('/');
		} else {
			let fullUserObj = this.globalCfgService.getFullUserObj();
			if (fullUserObj !== undefined && fullUserObj !== null) {
				this.runACLProcess(fullUserObj);
			} else {
				this.userService.getUserDetail(user['userId']).subscribe((response: any) => {
					let fullUserObjRes = response;
					this.globalCfgService.setFullUserObj(fullUserObjRes);
					this.runACLProcess(fullUserObjRes);
				});
			}
		}
		
		// if (Notification.permission === 'default') {
		// 	this.showRequestDialog();
		// } else if (Notification.permission === 'granted') {
		// 	// console.log('notifications allowed');
		// 	this.notifyService.requestPermission();
		// 	this.notifyService.receiveMessage();
		// }
	}

	runACLProcess(fullUserObj) {
		if (fullUserObj.role == 'brand-owner') {
			// this.miscService.getACL(response.gcp).subscribe(
				// 	(acls: any[]) => {
				// 		var acl = JSON.parse(acls[0].value);
				// 		this.globalCfgService.setAcl(acl);
					if (this.redirectService.redirectUrl != null) {
						this.redirectService.processRedirect(this.role);
					} else {
						this.ebService.onReadySource.next();
					}
			// 	}
			// );
		}
	}

	// showRequestDialog() {
	// 	const dialogRef = this.dialog.open(RequestNotificationDialogComponent, {
	// 		width: "450px"
	// 	})

	// 	dialogRef.afterClosed().subscribe(result => {
	// 		console.log("The dialog was closed", result);
	// 		if (result.enable === true) {
	// 			this.enableNotifications();
	// 		}
	// 	});
	// }

	// enableNotifications() {
	// 	this.notifyService.requestPermission();
	// 	this.notifyService.receiveMessage();
	// }

	ngOnDestroy() {
		this.subcriptions.forEach(s => s.unsubscribe());
	}
}